export const Functions = {
  create: false,
  delete: false,
  detail: true,
  search: true
};
export const PageName = '期号管理';